import styled from 'styled-components'
import { WebshopPackage } from '../../../schema/webshop-package'
import Heading from '../../../stories/atoms/Heading/Heading'

import ArrowRightSvg from '../../../stories/atoms/Icons/Button/ArrowRight'
import Link from '../../../stories/atoms/Link/Link'

import ProductCard from '../product-card/product-card'

const StyledHeading = styled(Heading)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 16px;
`

type OtherProductProps = {
  product: WebshopPackage
}

const OtherProduct = ({ product }: OtherProductProps) => (
  <div>
    <Link as={StyledHeading} href="/webshop">
      <StyledHeading>
        Andere producten
        <ArrowRightSvg height={14} />
      </StyledHeading>
    </Link>
    <ProductCard product={product} compact />
  </div>
)

export default OtherProduct
